import React, { FC } from 'react';

import AvatarComponent from '@components/AvatarComponent';
import useClient from '@lib/hooks/useClient';
import { helper } from '@utils/index';
import { usePrecision } from '@widget/airdrop/hooks/usePrecision';

import { ItemProps } from '../detail';

import styles from './index.module.less';

const ItemWeb: FC<ItemProps> = (props) => {
  const { receiveAvatar, receiveTime, currency, amount, receiveCode, receiveId } = props;
  const getRate = usePrecision({ coinCode: currency });
  return (
    <div className={styles.isPC}>
      <div className={styles.user}>
        <AvatarComponent
            customerId={receiveId}
            avatar={receiveAvatar}
            avatarSize={32}/>
        <div className={styles.code}>{receiveCode}</div>
      </div>
      <div className={styles.value}>{helper.formatFixNumString(amount, getRate)}{currency}</div>
      <div className={styles.date}>{helper.toLocaleTime(receiveTime)}</div>
    </div>
  );
}
export const ItemH5: FC<ItemProps> = (props) => {
  const { receiveTime, currency, amount, receiveCode } = props;
  const getRate = usePrecision({ coinCode: currency });
  return (
    <div className={styles.isMobile}>
      <div className={styles.phone}>{receiveCode}</div>
      <div className={styles.mes}>
        <div className={styles.date}>{helper.toLocaleTime(receiveTime)}</div>
        <div className={styles.value}>{helper.formatFixNumString(amount, getRate)}{currency}</div>
      </div>
    </div>
  );
};
export const Item: FC<ItemProps> = (props) => {
  const isPc = useClient();
  return (
    <div className={styles.container}>
      {isPc ? <ItemWeb {...props}/> : <ItemH5 {...props}/>}
    </div>
  );
};
